import React, { forwardRef } from 'react';

const Input = forwardRef(({
  type = 'text',
  name,
  id,
  value,
  onChange,
  placeholder,
  required = false,
  className = '',
  onKeyDown,
  maxLength,
  'data-testid': dataTestId,
  ...rest
}, ref) => {
  return (
    <input
      ref={ref}
      data-testid={dataTestId ?? (name ? `${name}-input` : 'input')}
      type={type}
      name={name}
      id={id}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      className={className}
      onKeyDown={onKeyDown}
      maxLength={maxLength}
      {...rest}
    />
  );
});

export default Input;
